import { createContext, useContext, type ReactNode } from 'react';

interface EffectiveDateContextValue {
  effectiveDate: string | null;
}

export const EffectiveDateContext = createContext<EffectiveDateContextValue>({
  effectiveDate: null,
});

interface EffectiveDateProviderProps {
  effectiveDate: string | null;
  children: ReactNode;
}

export const EffectiveDateProvider = ({
  effectiveDate,
  children,
}: EffectiveDateProviderProps) => {
  return (
    <EffectiveDateContext.Provider value={{ effectiveDate }}>
      {children}
    </EffectiveDateContext.Provider>
  );
};

export const useEffectiveDate = (): string | null => {
  const context = useContext(EffectiveDateContext);
  return context.effectiveDate;
};
